/* eslint-disable object-shorthand */

export var PACKAGE_BUILD_DATE = '2026-07-16T04:39:09.760Z';
export var PACKAGE_NAME = 'invision-customercare';
export var PACKAGE_VERSION = '26.3.10000-2415641';
export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};